<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师月度绩效考评' label2="导入带教老师月度绩效考评" url="/achievement/teach/scorerecordlist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">轮转科室：</label>
            <div class="col-xl-2">
              <el-form-item prop="section" :rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-bind:val_1="form.section" v-model="form.section" :dictid='this.$utils.DictEnum.section'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">轮转月份：</label>
            <div class="col-xl-2">
              <el-form-item prop="grantmonth" :rules="{required: true, message: '轮转月份不能为空', trigger: 'blur'}">
                <el-date-picker v-model="form.grantmonth" type="month" placeholder="轮转月份" value-format="yyyy-MM">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="col-xl-2">
              <el-button type="primary" @click="Out">下载模板</el-button>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">附件：</label>
            <div class="col-xl-10">
              <el-upload
                class="upload-demo"
                ref="upload"
                action
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :limit="1"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :http-request="submitFile"
                :auto-upload="false">
                <el-button slot="trigger" size="medium" type="primary">选取文件</el-button>
                <el-button style="margin-left: 10px;" size="medium" type="success" @click="submitUpload" v-loading.fullscreen.lock="fullscreenLoading">上传到服务器</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AchievementTecImport',
  data () {
    return {
      form: {
        token: '',
        section: '',
        grantmonth: '',
        file: null
      },
      fileList: [],
      fullscreenLoading: false
    }
  },
  methods: {
    Out: function () {
      window.location.href = this.$utils.Url.zpgl + '/template/带教老师月度绩效考评模板.xlsx'
    },
    submitUpload: function () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit()
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    handleRemove: function (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview: function (file) {
      console.log(file)
    },
    beforeAvatarUpload: function (file) {
      console.log(file.type)
      const isXLS = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 'application/vnd.ms-excel'
      if (!isXLS) {
        this.$message({
          message: '上传文件只能是 xls/xlsx 格式!',
          type: 'error'
        })
      }
    },
    submitFile: function (param) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', param.file)
      formData.append('token', this.form.token)
      formData.append('section', this.form.section)
      formData.append('grantmonth', this.form.grantmonth)
      console.log(formData)
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/UploadTec', formData, {'Content-Type': 'multipart/form-data'})
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            this.$message({
              message: '上传成功',
              type: 'success'
            })
            console.log('上传成功')
            this.$router.push('/main/achievement/teach/scorerecordlist')
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Data,
              type: 'error'
            })
          }
          this.fullscreenLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '上传失败',
            type: 'error'
          })
          this.fullscreenLoading = false
        })
    }
  },
  mounted: function () {
    this.form.token = sessionStorage.getItem('token')
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    this.form.grantmonth = year + '-' + month
  }
}
</script>

<style>
</style>
